import type { Lang } from "../lib/types";

// 워드마크: 소문자 hyuh, 달빛 글로우. JP 무드용 서브마크 ほっ(설정/라이트 무드).
export default function Logo({ size = 22, lang = "ko" }: { size?: number; lang?: Lang }) {
  return (
    <span className="logo">
      <span className="logo-dot" style={{ width: size, height: size }} />
      <span className="logo-word" style={{ fontSize: Math.round(size * 0.7) }}>
        {lang === "ja" ? "ほっ" : "hyuh"}
      </span>
    </span>
  );
}
